export default __webpack_public_path__ + "static/pacific-book-review-a87695250841f4d7de14b1eb37de192a.png";